import Handlebars from "handlebars"; Handlebars.registerPartial("loader", Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"loading-container in-content\">\n  <div class=\"loading\"></div>\n</div>\n";
},"useData":true}));